import { Component, OnInit } from '@angular/core';
import { EmailService } from 'src/app/services/email.service';

@Component({
  selector: 'app-contact-box',
  templateUrl: './contact-box.component.html',
  styleUrls: ['./contact-box.component.scss']
})
export class ContactBoxComponent implements OnInit {

  constructor(private emailService: EmailService) { }

  ngOnInit() {
  }

  emailEnviado = false;

  form = {
    nome: '',
    email: '',
    empresa: '',
    telefone: '',
    assunto: '',
    mensagem: ''
  };

  onSubmit() {
    if (this.isFormValid()) {
      this.emailService.sendMail(this.form).then(
        (r) => {
          this.emailEnviado = true;
        }).catch(e => {
          console.error('Erro ao enviar email:', e);
        });
    }
  }

  isFormValid(): boolean {
    return (
      this.form.nome.trim() !== '' &&
      this.form.email.trim() !== '' &&
      this.form.empresa.trim() !== '' &&
      this.form.telefone.trim() !== '' &&
      this.form.assunto.trim() !== '' &&
      this.form.mensagem.trim() !== ''
    );
  }

  resetForm() {
    this.form = {
      nome: '',
      email: '',
      empresa: '',
      telefone: '',
      assunto: '',
      mensagem: ''
    };
  }

  enviarOutro(){
    this.emailEnviado = !this.emailEnviado;
    this.resetForm();
  }
}
